"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateFee = void 0;
var Fees_1 = require("../types/Fees");
// This can be extended in the future to calculate fee based on subscription level rather than take a fee amount.
function calculateFee(amount, fee) {
    if (fee === void 0) { fee = Fees_1.Fees.Standard; }
    var _fee = fee * amount;
    return amount + _fee;
}
exports.calculateFee = calculateFee;
